import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/models/list';
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Create new action types for silent requests
export const SILENT_REQUEST = 'SILENT_MODELS_LIST_REQUEST';

// Common function for processing both silent and regular requests
function* fetchModelsData(action) {
  try {
    const { page = 1, rowsPerPage = 10, sortColumn = '', sortDirection = '' } = action.payload || {};
    const isSilent = action.type === SILENT_REQUEST;
    
    // If this is not a silent refresh, trigger loading state
    if (!isSilent) {
      yield put({ type: 'MODELS_LIST_LOADING', payload: true });
    }
    
    const response = yield call(
      axios.get,
      `${config.API_URL}/pipelines?page=${page}&per_page=${rowsPerPage}${sortColumn ? `&sort_column=${sortColumn}` : ''}${sortDirection ? `&sort_direction=${sortDirection}` : ''}`,
      { headers: getLocalUser() }
    );
    
    yield put(fetchSuccess(response.data.data));
    
    // If this was a silent refresh, dispatch an additional action for tracking
    if (isSilent) {
      yield put({ type: 'MODELS_LIST_SILENTLY_UPDATED', timestamp: new Date().getTime() });
    }
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  } finally {
    if (action.type !== SILENT_REQUEST) {
      // Reset loading state for non-silent requests
      yield put({ type: 'MODELS_LIST_LOADING', payload: false });
    }
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchModelsData);
  yield takeLatest(SILENT_REQUEST, fetchModelsData);
}